/* Special Requests form (sections/ac-sr-page.liquid).

   Three small behaviours on top of Shopify's contact form, all optional —
   the form posts fine without them:

   1. "Already ordered?" No hides and disables the order-number field so
      nothing stale is posted; Yes shows and enables it.
   2. A URL typed without a scheme gets https:// on change and on submit,
      so the browser's URL validation does not reject "artisticases.com/…".
   3. The submit button locks with a "Sending…" label once the browser's
      constraint validation has passed, so a double tap cannot post twice.

   Re-runs safely when the theme editor re-renders the section. */
(function () {
  'use strict';

  function addScheme(input) {
    var v = input.value.trim();
    if (v && !/^[a-z][a-z0-9+.-]*:/i.test(v)) input.value = 'https://' + v;
  }

  function init(root) {
    var form = root.querySelector('[data-ac-sr-form]');
    if (!form || form.dataset.acSrReady) return;
    form.dataset.acSrReady = '1';

    var wrap = form.querySelector('[data-ac-sr-order-wrap]');
    var order = wrap && wrap.querySelector('input');
    var radios = form.querySelectorAll('[data-ac-sr-ordered]');
    var urls = form.querySelectorAll('[data-ac-sr-url]');
    var submit = form.querySelector('[data-ac-sr-submit]');
    var notice = form.querySelector('[data-ac-sr-notice]');
    var submitLabel = submit ? submit.textContent : '';

    function syncOrder() {
      if (!wrap || !order) return;
      var yes = form.querySelector('[data-ac-sr-ordered="yes"]');
      var show = !!(yes && yes.checked);
      wrap.hidden = !show;
      order.disabled = !show;
      if (!show) order.value = '';
    }
    for (var i = 0; i < radios.length; i++) radios[i].addEventListener('change', syncOrder);
    syncOrder();

    for (var j = 0; j < urls.length; j++) {
      urls[j].addEventListener('change', function (e) { addScheme(e.target); });
    }

    form.addEventListener('submit', function (e) {
      for (var k = 0; k < urls.length; k++) addScheme(urls[k]);
      if (!form.checkValidity()) return;
      if (form.dataset.acSrSending) { e.preventDefault(); return; }
      form.dataset.acSrSending = '1';
      if (submit) {
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        if (submit.dataset.sendingLabel) submit.textContent = submit.dataset.sendingLabel;
      }
    });

    // Back/forward cache can restore a locked button; unlock it.
    window.addEventListener('pageshow', function () {
      delete form.dataset.acSrSending;
      if (submit) { submit.disabled = false; submit.removeAttribute('aria-busy'); submit.textContent = submitLabel; }
    });

    // Put the server's success / error notice in front of assistive tech.
    if (notice) notice.focus({ preventScroll: false });
  }

  function boot() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
